/* eslint-disable no-console */
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2';
import store from './store'
import Vuex from 'vuex'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import isNull from "lodash/isNull";

import './plugins/tiptap-vuetify'

const options = {
  textColor: '#41b882',
};
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.config.devtools = true;
Vue.use(VueSweetalert2, options);

const qs = require('qs')


sync(store, router)


if(process.env.VUE_APP_SENTRY_ENABLE === '1') {
  Sentry.init({
    Vue,
    dsn: "https://1c02c96b7a714cf48b901e102fe1f9ed@svr221.street-directory.com.au:9001/7",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          "localhost:8080",
          "city-councils-dev.street-directory.com.au",
          "local-government.street-directory.com.au",
          /^\//
        ],
      }),
    ],
    tracesSampleRate: 0.25,
  });
}

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

router.beforeEach((to, from, next) => {
  const toRoute = to.path.split('/').filter(t => t !== '');
  if (toRoute[0] === 'register') {
    return axios.post(`${process.env.VUE_APP_API_URL}/validate_hash`, qs.stringify({ hash: toRoute[1] }))
      .then((response) => {
        if (response) {
            if (response.data.data.valid) {
              next()
            } else {
              next('/login')
              return
            }
        }
      })
  }

  if (store.state.token) {
    if (toRoute[0] === 'message') return next(from.path);
    return axios.post(`${process.env.VUE_APP_API_URL}/check_token`, qs.stringify({
      token : store.state.token
    }))
      .then(
        (response) => {
          if (response.data.code === 401) {
            new Promise((resolve, reject) => {
              try {
                localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
              } catch (e) {}
              resolve();
            })
            .then(
              () => {
                store.commit('ERROR_STATUS', false)
                store.commit('REMOVE_DATA')
              }
            )
            if (process.env.VUE_APP_SSO) {
              if (process.env.VUE_APP_WEB === 'yarra') {
                window.location.href = process.env.VUE_APP_SSO;
                return;
              } else {
                if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
                  const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
                  window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
                  return;
                }
              }
            }
            next('/login')
          } else {
            if (to.path === '/login' || toRoute[0] === 'bypass') {
              window.location.href = `${process.env.VUE_APP_CARPOOLING_URL}/#/book`;
              setTimeout(() => {
                location.reload();
              }, 2e3)
            } else {
              next();
            }
          }
        }
      )
  } else if (toRoute[0] === 'message') {
    next();
  } else if (!store.state.token && toRoute[0] === 'bypass') {
    const token = toRoute[1];
    const payload = qs.stringify({ token });
    const url = `${process.env.VUE_APP_API_URL}/check_token`;
    axios.post(url, payload)
      .then((response) => {
        if (response.data.code === 401) {
          if (process.env.VUE_APP_SSO) {
            if (process.env.VUE_APP_WEB === 'yarra') {
              window.location.href = process.env.VUE_APP_SSO;
              return;
            } else {
              if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
                const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
                window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
                return;
              }
            }
          }
          next('/login')
        } else {
          const url_load_user = `${process.env.VUE_APP_API_URL}/get_user_by_token`;
          axios.post(url_load_user, payload)
            .then((resp) => {
              const { user } = resp.data.data;
              user.token = token;
              new Promise((resolve, reject) => {
                try {
                  localStorage.setItem(`USER_DATA_${STORAGE_NAME}`, JSON.stringify({
                    token,
                    user_id: user.id,
                    user: {
                      username: user.username,
                      type: user.type,
                      clientid: user.clientid,
                    },
                    response_login: resp.data.data
                  }))
                } catch (e) {}
                try {
                  localStorage.setItem(`CLIENTID_${STORAGE_NAME}`, user.clientid);
                } catch (e) {}
                resolve();
              })
              .then(() => {
                user.sso = true;
                const current_user_data = {user, token};
                store.commit('SET_DATA', current_user_data);
                store.commit('ADD_USER_DATA', current_user_data);
              })
              .finally(() => {
                window.location.href = `${process.env.VUE_APP_CARPOOLING_URL}/#/book`;
                setTimeout(() => {
                  location.reload();
                }, 2e3)
              });
            });
        }
      });
  } else if (isNull(store.state.token) && to.path !== '/login' && to.name !== 'register' && to.name !== 'reset_password') {
    if (process.env.VUE_APP_SSO) {
      if (process.env.VUE_APP_WEB === 'yarra') {
        window.location.href = process.env.VUE_APP_SSO;
        return;
      } else {
        if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
          const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
          window.location.href = `${process.env.VUE_APP_SSO}${clientid}`;
          return;
        }
      }
    }
    next('/login')
  } else if (!store.state.token && to.path === '/login') {
    if (process.env.VUE_APP_SSO) {
      let loginUrl = process.env.VUE_APP_SSO;
      if (process.env.VUE_APP_WEB === 'yarra') {
        if (store.state.logout_from_button) loginUrl = `${loginUrl}/yes`;
        window.location.href = loginUrl;
        return;
      } else if (localStorage.getItem(`CLIENTID_${STORAGE_NAME}`)) {
        const clientid = localStorage.getItem(`CLIENTID_${STORAGE_NAME}`);
        window.location.href = `${loginUrl}${clientid}&relogin=1`
        return;
      }
    }
    next()
  } else {
    next()
  }
})

store.dispatch('LOAD_TOKEN')
  .then(() => {
    new Vue({
      Vuex,
      router,
      Sentry,
      store,
      vuetify,
      vSelect,
      render: h => h(App)
    }).$mount('#app')
  })
